import { armorProperty } from 'src/tracker/model/property/equipment/armor/armor-property'
import { Resource } from 'src/tracker/model/tracker-model'
import { createStandardCharacterResourceProperty } from '../resource-meta/character-resource-property'

export const highArmorTokenProperty = createStandardCharacterResourceProperty(
  '163379db-06f4-4f60-82b1-8b7929f42b3d',
  'High Armor Tokens',
  'highArmorTokens',
  armorProperty,
  Resource.HIGH_ARMOR_TOKENS,
)
